import { initialValidations } from "_common/ssrWrapper";
import ReelsPage              from "_components/pages/reels";
import { getFeedById }        from "_services/api/feed";

const component = props => {

	return (
		<ReelsPage
			error    = { props.error }
			reelById = { props.reelById }
		/>
	);
};

export default component;

export const getServerSideProps = async context => initialValidations ( context, async ( defaultProps, context ) => {

	const reelId = context.query.id;

	let error       = null;
	let reelById    = null;
	let forceLogout = false;

	const results = await Promise.allSettled ( [
		getFeedById.bind ( defaultProps ) ( { feedId: parseInt ( reelId ) } )
	] );

	results.forEach ( ( result, index ) => {
		if ( result.status === "fulfilled" ) {
			switch ( index ) {
				case 0:
					reelById = result.value;
					break;

			}
		}

		if ( result.status == "rejected" ) {
			error = result.reason;
		}

		if ( result.status === "rejected" && result.reason?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
			forceLogout = true;
	} );

	if ( forceLogout )
		return {
			redirect: {
				destination : `/logout?forceLogout=${ true }&prevLocation=${ defaultProps?.currentPath }`,
				permanent   : false
			}
		};

	if ( !defaultProps?.isLoggedIn && reelById )
		context.res.setHeader (
			"Cache-Control",
			"public, s-maxage=90, stale-while-revalidate=120"
		);

	return {
		props: {
			...defaultProps,
			reelById,
			noLayout: defaultProps?.isMobile ? true : false,
			error
		}
	};
} );
